import React from "react";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const returnDate = (d) => {
  return new Date(d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
};

const MaximumInteractions = ({ activity }) => {
  const navigate = useNavigate();
  return (
    <>
      {activity ? (
        <>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr>
                <th>User</th>
                <th>Message Count</th>
                <th>Last Interaction</th>
                <th>ConnectionID</th>
              </tr>
            </thead>
            {activity.length > 0 &&
              activity.map((res, i) => {
                if (res.otherUser && res.otherUser?.name)
                  return (
                    <tr key={i} className="my-2 pt-2">
                      <td
                        onClick={() =>
                          navigate(
                            `/admin/user-activity?tab=13&userid=${res.otherUser?._id}`
                          )
                        }
                        className="pointer my-2 pt-2"
                      >
                        <Avatar
                          src={res.otherUser ? res.otherUser.avatar : ""}
                        />
                        {res.otherUser
                          ? `${res.otherUser.name} (${res.otherUser.type}) `
                          : ""}
                      </td>
                      <td className=" my-2 pt-2">{res.messageCount}</td>
                      <td className=" my-2 pt-2">
                        {returnDate(res.lastInteractedAt)}
                      </td>
                      <td className=" my-2 pt-2">{res._id}</td>
                    </tr>
                  );
              })}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default MaximumInteractions;
